module.exports = __webpack_public_path__ + "static/media/right-arrow-bronze.a9005af0.svg";